import { useMediaQuery } from '@/hooks/use-media-query'

// Use this to switch off scroll-linked motion. MotionConfig in _app already
// handles entrance animations for visitors who ask for reduced motion.
export const usePrefersReducedMotion = (): boolean => useMediaQuery('(prefers-reduced-motion: reduce)')
